import { Component, effect, inject, input, model, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { InputFieldComponent } from '@zayan-erp/shared';
import { DynamicRouteHandlingService } from 'libs/shared/src/lib/services/dynamic-route-handling.service';
import { ProductAttributeService } from '../../services/product-attribute.service';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule, ToggleSwitchModule, InputFieldComponent],
  selector: 'lib-attribute-value-form',
  templateUrl: './attribute-value-form.component.html'
})
export class AttributeValueFormComponent {
  #productAttributeService = inject(ProductAttributeService);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #modalService = inject(NgbModal);

  submitButton = model<boolean>(false);
  selectedAttributeTypeId = input<string | null>(null);
  selectedAttributeValueId = input<string | null>(null);

  constructor() {
    effect(() => {
      if (this.submitButton()) {
        this.submitAttributeValueForm();
      }
    });
  }

  attributeValueForm = new FormGroup({
    id: new FormControl<string | null>(this.selectedAttributeValueId()),
    value: new FormControl<string[]>([], Validators.required)
  });

  submitAttributeValueForm() {
    if (this.attributeValueForm.invalid) {
      this.attributeValueForm.markAllAsTouched();
      return;
    }
    if (this.selectedAttributeValueId()) {
      this.#productAttributeService
        .updateProductAttributeValue(this.selectedAttributeValueId()!, this.attributeValueForm.value.value!)
        .subscribe(() => {
          this.attributeValueForm.reset();
          this.#modalService.dismissAll();
          this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
        });
    } else {
      this.#productAttributeService
        .createProductAttributeValue(this.selectedAttributeTypeId()!, this.attributeValueForm.value.value!)
        .subscribe(() => {
          this.attributeValueForm.reset();
          this.#modalService.dismissAll();
          this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
        });
    }
  }
}
